import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dept",
  "use": "icon-dept-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dept\"><defs><style type=\"text/css\"></style></defs><path d=\"M400.2 777.2H127.8V504.8h272.4v272.4z m382.2-271.9H510v272.4h272.4V505.3z\" fill=\"#CFD8DC\" p-id=\"867\" /><path d=\"M319.4 97.8h272.8v272.8H319.4z\" fill=\"#78909C\" p-id=\"868\" /><path d=\"M692.9 504.8h-40v-46.7H257v46.7h-40v-83.7h2.9v-3h215v-47.2h40v47.2h215.3v3.4h2.7z\" fill=\"#CFD8DC\" p-id=\"869\" /><path d=\"M555.2 742.5c0 102.8 83.3 186.2 186.1 186.3s186.2-83.3 186.3-186.1v-0.1c0-102.8-83.3-186.2-186.1-186.3s-186.2 83.3-186.3 186.2z\" fill=\"#43A047\" p-id=\"870\" /><path d=\"M825.2 655L719.1 761.2l-50.3-50.3-39.1 41 89.4 89.4L864.3 696l-39.1-41z\" fill=\"#DCEDC8\" p-id=\"871\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dept.svg
// module id = ynRI
// module chunks = 307